module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto o email é processado..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'ENVIAR ASO POR EMAIL' +
        (_vm.parent.consulta ? ' - CONSULTA ' + _vm.parent.consulta.id_con : ''),
      "modal": _vm.parent.showDownloadASO,
      "loadingSave": _vm.loadingSave,
      "loading": _vm.parent.loadingDownloadASO,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar novo Email\n          ")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Informe abaixo o destinatário. Você pode adicionar vários emails separado por ; (ponto e vírgula).",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.parent.consulta ? true : false,
      "value-key": "id"
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.empresa),
      callback: function($$v) {
        _vm.empresa = $$v
      },
      expression: "empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                      " + _vm._s(item.cnpj) + "\n                    ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Destinatário",
      "prop": "destinatario",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Digite o destinatário (separado por `;` ponto e vírgula)",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.destinatario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "destinatario", $$v)
      },
      expression: "formData.destinatario"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Observações",
      "prop": "obs",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "O conteúdo deste campo será anexado junto com o email enviado para o destinatário...",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                  Consulta\n                  "), _c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.id_emp || (_vm.parent.consulta ? true : false)
    },
    model: {
      value: (_vm.formData.todos),
      callback: function($$v) {
        _vm.$set(_vm.formData, "todos", $$v)
      },
      expression: "formData.todos"
    }
  }, [_vm._v("Selecionar Todas as Consultas")])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": _vm.formData.todos == 1 ||
        !_vm.formData.id_emp ||
        (_vm.parent.consulta ? true : false),
      "value-key": "id_con"
    },
    model: {
      value: (_vm.formData.consultas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consultas", $$v)
      },
      expression: "formData.consultas"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item,
        "label": 'CÓD ' +
          item.id_con +
          ((item.dt_cad ?
              ' | ' + _vm.toDate(item.dt_cad, true) :
              '') +
            (item.tipo_aso ?
              ' | ' + item.tipo_aso.descricao.toUpperCase() :
              '') +
            (item.tipo_status ?
              ' | ' + item.tipo_status.descricao.toUpperCase() :
              ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                      CÓD " + _vm._s(item.id_con) + " |\n                      " + _vm._s(item.dt_cad ? _vm.toDate(item.dt_cad, true) : "") + " |\n                      " + _vm._s(item.tipo_aso ?
      item.tipo_aso.descricao.toUpperCase() :
      "") + "\n                      " + _vm._s(item.tipo_status ?
      " | " + item.tipo_status.descricao.toUpperCase() :
      "") + "\n                    ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Anexar os Seguintes Documentos",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.formData.tipo_documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo_documento", $$v)
      },
      expression: "formData.tipo_documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(tipo) {
    return _c('el-checkbox', {
      key: tipo.id,
      staticStyle: {
        "width": "100% !important"
      },
      attrs: {
        "label": tipo.id,
        "disabled": !_vm.formData.id_emp
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.consultas.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-hover has-gutter",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "400"
    }
  }, [_vm._v("CONSULTA")]), _vm._v(" "), _c('th', [_vm._v("DOCUMENTOS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.formData.consultas), function(consulta, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_vm._v("CÓD:")]), _vm._v("\n                        " + _vm._s(consulta.id_con) + "\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.funcionario.nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.empresa.nome))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            Atestado de Saúde Ocupacional\n                            "), _c('br')]), _vm._v(" "), (consulta.arquivo_aso) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_aso)
        }
      }
    }, [_c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_aso
      }
    })], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                    Páginas\n                                  ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (consulta.arquivo_aso.select_pages),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_aso, "select_pages", $$v)
        },
        expression: "consulta.arquivo_aso.select_pages"
      }
    }, _vm._l((consulta.arquivo_aso.pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)]) : _c('p', [_vm._v("Nenhum arquivo")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            Exames Complementares\n                            "), _c('br')]), _vm._v(" "), (consulta.arquivo_prontuario) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_prontuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_prontuario
      }
    })], 1), _vm._v(" "), _c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                  Páginas\n                                ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (
          consulta.arquivo_prontuario.select_pages
        ),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_prontuario, "select_pages", $$v)
        },
        expression: "\n                                consulta.arquivo_prontuario.select_pages\n                              "
      }
    }, _vm._l((consulta.arquivo_prontuario
      .pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1) : _c('p', [_vm._v("Nenhum arquivo")])])])])])
  }), 0)])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n            Histórico de Envio de Emails\n          ")]), _vm._v(" "), _c('DownloadAsoEmail', {
    ref: "downloadAsoEmailComponent",
    attrs: {
      "parent": _vm.parent
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c33f2e76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/liberacao/_includes/download-aso.vue
// module id = 1494
// module chunks = 44